import { Action } from '@ngrx/store';
import * as Actions from './formio-role-checker.actions';
import { IFormioRoleCheckerState } from './formio-role-checker.model';

export const formioESignatureState: IFormioRoleCheckerState = {
  controlRoleFormioRoleCheckerLoading: false,
  controlRoleFormioRoleCheckerLoaded: false,
};

export function formioRoleCheckerReducer(
  state: IFormioRoleCheckerState = formioESignatureState,
  baseAction: Action,
): IFormioRoleCheckerState {
  const action: Actions.FormioRoleCheckerActions = baseAction as Actions.FormioRoleCheckerActions;
  switch (action.type) {
    case Actions.CONTROL_ROLE_FORMIO_ROLE_CHECKER:
      return {
        ...state,
        controlRoleFormioRoleCheckerLoading: true,
        controlRoleFormioRoleCheckerLoaded: false,
      };
    case Actions.CONTROL_ROLE_FORMIO_ROLE_CHECKER_COMPLETED:
      return {
        ...state,
        controlRoleFormioRoleCheckerLoading: false,
        controlRoleFormioRoleCheckerLoaded: true,
      };
    default:
      return state;
  }
}
